import Cookies from "js-cookie";

const KEY_LATEST_ORDER_ID = "kingdynasty_ec_latest_order_id";

const getDefaultState = () => ({
  latestOrderId: Cookies.get(KEY_LATEST_ORDER_ID)
});

const state = getDefaultState();

const mutations = {
  SET_LATEST_ORDER_ID: (state, latestOrderId) => {
    state.latestOrderId = latestOrderId;
  }
};

const actions = {
  refreshLatestOrderId({ commit }, latestOrderId) {
    Cookies.set(KEY_LATEST_ORDER_ID, latestOrderId);
    commit("SET_LATEST_ORDER_ID", latestOrderId);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};